export const exercisesOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': '15bfe97877mshf8ab477773c68b8p104b17jsn2fa6564d64ee',
    'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
  }
};

export const youtubeOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Host": "youtube-search-and-download.p.rapidapi.com",
    "X-RapidAPI-Key": '908d5d8a96msh72bce9a04b12ddfp190b4bjsn4e985eda6856',
  },
};

export const fetchData = async (url, options) => {
  try {
    const res = await fetch(url, options);
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export default fetchData;